import { Dispatch } from 'redux';
import { IntermittentFaultsActionTypes, IntermittentFault } from '.';

const saveIntermittentFaults =
  ({ payload }: { payload: IntermittentFault[] }) =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch({
      type: IntermittentFaultsActionTypes.SAVE_ALL,
      payload,
    });
  };

export default saveIntermittentFaults;
